import { MigrationInterface, QueryRunner } from 'typeorm'

export class AddEmailTemplateSettings1701251584177 implements MigrationInterface {
	name = 'AddEmailTemplateSettings1701251584177'

	public async up(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "settings" ADD "emailTemplates" json`)
	}

	public async down(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "settings" DROP COLUMN "emailTemplates"`)
	}
}
